import React, { useMemo, Children } from 'react'
import PropTypes from 'prop-types'

import { Box, ListItem, ListItemText, useTheme, Skeleton } from '@mui/material'

import { HHAlert } from 'components/common/HHAlert'

import T from 'T'
import HistoryListItem from './HistoryListItem'

const GracePeriodHistory = ({ isLoading = false, rows = [], ...rest }) => {
  const theme = useTheme()
  const hasRows = useMemo(() => rows.length > 0, [rows])

  return (
    <>
      {isLoading && (
        <ListItem {...rest}>
          <ListItemText primary={<Skeleton variant="text" width="15rem" />} secondary={<Skeleton variant="text" width="7rem" />} />
        </ListItem>
      )}
      {!isLoading && (
        <>
          {!hasRows && (
            <Box p={2}>
              <HHAlert severity="info" borderColor={theme.palette.info.light}>
                {T.NO_GRACE_PERIOD_RESET_HISTORY}
              </HHAlert>
            </Box>
          )}
          {hasRows &&
            Children.toArray(
              rows.map((history, index) => <HistoryListItem history={history} showDivider={index < rows.length - 1} {...rest} />)
            )}
        </>
      )}
    </>
  )
}

GracePeriodHistory.propTypes = {
  isLoading: PropTypes.bool,
  rows: PropTypes.array,
}

export default GracePeriodHistory
